<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view v-if="showView"/>
    </transition>
    <nav-bar v-show="navBarVisiable"/>
    <mini-map v-show="miniMapVisiable"/>
    <img class="full-screen-btn" :src="require(`./assets/img/icon/fullScreen-${ isScreenFull ? 'quit' : 'enter' }.png`)" alt="全屏按钮" @click="toggleScreenFull">
    <img v-show="qrVisiable" class="qr" :src="require('./assets/img/icon/mobile-qr.jpg')" alt="扫码浏览">
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'App',
  provide () {
    return {
      app: this,
    }
  },
  data () {
    return {
      showView: true,
      screenfull,
      timer: null,
      isScreenFull: false,
    }
  },
  computed: {
    miniMapVisiable () {
      const list = [
        'home',
        'Start',
        'DynamicPicture',
        'End',
      ]
      return !~list.indexOf(this.$route.name)
    },
    navBarVisiable () {
      const list = [
        'home',
        'Start',
        'DynamicPicture',
        'End',
      ]
      return !~list.indexOf(this.$route.name)
    },
    qrVisiable () {
      const list = [
        'home',
        'End',
      ]
      return !~list.indexOf(this.$route.name)
    },
  },
  mounted () {
    this.resize()
    window.onresize = this.debounce(this.resize, 500)
  },
  methods: {
    toggleScreenFull () {
      screenfull.toggle(document.body)
    },
    debounce (fn, time) {
      this.timer = null
      return () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(fn, time)
      }
    },

    resize () {
      this.$nextTick(() => {
        const docEl = document.documentElement
        const baseRate = 1920 / 1080
        const rate = docEl.clientWidth / docEl.clientHeight
        let width = 0
        if (rate < 1) {
          location = 'http://zg.southcn.com/bridge/m/index.html'
        }
        if (rate > baseRate) {
          width = docEl.clientHeight * baseRate
        } else {
          width = docEl.clientWidth
        }
        docEl.style.fontSize = 100 * (width / 1920) + 'px'
        this.isScreenFull = screenfull.isFullscreen
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/scss/index.scss';
.full-screen-btn {
  position: absolute;
  top: 0.2rem;
  right: 0;
  left: 0;
  width: 2rem;
  margin: 0 auto;
  cursor: pointer;
  opacity: 0.4;
  transition: all 0.5s;
  &:hover {
    opacity: 1;
  }
}
.qr {
  position: absolute;
  right: 0.05rem;
  bottom: 0.05rem;
  z-index: 10000;
  display: block;
  width: 1.1rem;
  height: 1.275rem;
}
</style>
